import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { init, reactRouterV6BrowserTracingIntegration } from '@sentry/react';

const env = import.meta.env.VITE_SENTRY_ENVIRONMENT;

function getRate(environment: string): number {
  switch (environment) {
    case 'development':
      return 0;
    case 'qa':
      return 0.5;
    case 'staging':
      return 0.25;
    case 'pre-production':
      return 1;
    case 'production':
      return 0.25;
    default:
      return 0;
  }
}

export default function initializeSentry() {
  init({
    dsn: 'https://d06ee2857c0011d4f1aabb87595976ce@o4508456417427456.ingest.us.sentry.io/4508457087336448',
    environment: env,
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        createRoutesFromChildren,
        matchRoutes,
        useEffect,
        useLocation,
        useNavigationType,
      }),
    ],
    // Tracing
    tracesSampleRate: getRate(env), // Set tracesSampleRate based on environment
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      import.meta.env.VITE_BASE_API_URL,
      import.meta.env.VITE_VOUCHED_CALLBACK_BASE_API_URL,
    ],
    propagateTraceparent: true,
  });
}
